import {
  CheckCircle2,
  ClipboardList,
  Edit3,
} from 'lucide-react';

import { formatMoney } from '../../../../utils/decimalValue';

interface PurchaseSummaryProps {
  totalCount: number;
  draftCount: number;
  confirmedTotal: number;
}

const PurchaseSummary = ({
  totalCount,
  draftCount,
  confirmedTotal,
}: PurchaseSummaryProps) => {
  return (
    <div
      className="
        grid
        grid-cols-1
        gap-4

        border-b
        border-stroke

        bg-gray-2/40

        p-5

        dark:border-strokedark
        dark:bg-boxdark-2/30

        sm:grid-cols-3
        sm:px-7
      "
    >
      {/* =====================================================
          🔹 Compras encontradas
      ===================================================== */}

      <article
        className="
          rounded-xl

          border
          border-stroke

          bg-white

          p-4

          shadow-card-2

          dark:border-strokedark
          dark:bg-boxdark
          dark:shadow-none
        "
      >
        <p
          className="
            flex
            items-center
            gap-2

            text-xs
            font-semibold
            uppercase
            tracking-wide
            text-bodydark2
          "
        >
          <ClipboardList className="h-4 w-4 text-primary" />

          Compras encontradas
        </p>

        <p
          className="
            mt-2

            text-2xl
            font-bold
            text-black

            dark:text-white
          "
        >
          {totalCount.toLocaleString('es-SV')}
        </p>
      </article>

      {/* =====================================================
          🔹 Pendientes
      ===================================================== */}

      <article
        className="
          rounded-xl

          border
          border-stroke

          bg-white

          p-4

          shadow-card-2

          dark:border-strokedark
          dark:bg-boxdark
          dark:shadow-none
        "
      >
        <p
          className="
            flex
            items-center
            gap-2

            text-xs
            font-semibold
            uppercase
            tracking-wide
            text-bodydark2
          "
        >
          <Edit3 className="h-4 w-4 text-warning" />

          Pendientes de confirmar
        </p>

        <p className="mt-2 text-2xl font-bold text-warning">
          {draftCount.toLocaleString('es-SV')}
        </p>
      </article>

      {/* =====================================================
          🔹 Total confirmado
      ===================================================== */}

      <article
        className="
          rounded-xl

          border
          border-stroke

          bg-white

          p-4

          shadow-card-2

          dark:border-strokedark
          dark:bg-boxdark
          dark:shadow-none
        "
      >
        <p
          className="
            flex
            items-center
            gap-2

            text-xs
            font-semibold
            uppercase
            tracking-wide
            text-bodydark2
          "
        >
          <CheckCircle2 className="h-4 w-4 text-success" />

          Total confirmado
        </p>

        <p className="mt-2 text-2xl font-bold text-success">
          {formatMoney(confirmedTotal)}
        </p>
      </article>
    </div>
  );
};

export default PurchaseSummary;